import { isDingdingMiniapp } from "../_utils/miniappEnvApp";
import { CONTAINER_NAME } from "../_utils/constant";
import { normalizeGet } from "../common";
var getClipboard = normalizeGet(function (args) {
  return isDingdingMiniapp ? dd.getClipboard(args) : my.getClipboard(args);
}, CONTAINER_NAME.ALIPAY);
export default getClipboard;